import { HttpClient } from '@angular/common/http';
import {Component, OnDestroy, OnInit, Inject} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';

import {GroupService} from '../../services/group.service';
import {map, startWith, take, takeUntil, tap} from 'rxjs/operators';

import {Observable, Subject, of, throwError} from 'rxjs';
import { Group } from '../../models/group';
import { AlertDialog, AlertDialogConfig } from '../alert/dialog';
import { Ec2Service } from '../../services/ec2.service';

@Component({
  standalone: false,
  selector: 'app-resource-user',
  templateUrl: './add-resource-template.html',
  styleUrls: ['./add-resource-style.scss'],
})
export class AddResourceComponent implements OnInit, OnDestroy {
  showMoreOptions_ = false;
  loading: Boolean= true;
  isExternal = false;
  userForm!:  FormGroup;
  readonly nameMaxLength = 24;
  private created_ = false;
  private unsubscribe_ = new Subject<void>();
  resourcesListDictionary : Array<any> = [];
  filteredResourcesByName!: Observable<any[]> | undefined ;
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<AddResourceComponent>,
    private groupService: GroupService,
    private ec2Service: Ec2Service,
    private readonly route_: ActivatedRoute,
    private readonly fb_: FormBuilder,
    private readonly dialog_: MatDialog,
    private readonly router_: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  get name(): AbstractControl | null {
    return this.userForm.get('name');
  }

  get resources() : FormGroup {
    return this.userForm.get("resources") as FormGroup
  }

  get usePattern() : AbstractControl | null {
    return this.userForm.get('usePattern');
  }

  dump(o:any){
    console.log(' ==> o = ', o)
  }

  ngOnInit(): void {
    this.ec2Service.get()
          .subscribe(result => {
            this.resourcesListDictionary = result;
            this.loading = false
          }
          );
    this.userForm = this.fb_.group({
      usePattern: [false, []],
      name: ['', [ ]],
      resources: ['', [Validators.required]],
    });
    this.filteredResourcesByName = this.userForm.get('resources')?.valueChanges
            .pipe(
              startWith(''),
              map(value => this._filter(value || ''))
            )|| of(this.resourcesListDictionary.map(item => item.name));

  }

  ngOnDestroy(): void {
    this.unsubscribe_.next();
    this.unsubscribe_.complete();
  }

  hasUnsavedChanges(): boolean {
    return this.userForm.dirty;
  }

  isCreateDisabled(): boolean {
    return !this.userForm.valid && !this.submitting;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  add(): void {
    // this.submitting = true;
    const resource =  {
      name: (this.resources)? this.resources.value.trim() : null,
      group: this.data.group
    }

    this.groupService.addResource(resource)
    .subscribe( _ => {
      if(!_.status){
        const config = {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de l\'ajout de cet utilisateur : ' + _.message,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
      }else{
        const config = {
          title: 'Ajouté !',
          message: _.message,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
        this.dialogRef.close();
      }
      this.loading = false;
    },
    error => {
      const config = {
        title: 'Erreur',
        message: 'Une erreur est survenue lors de l\'ajout de cet utilisateur : ' + error,
        confirmLabel: 'OK'
      } as AlertDialogConfig;
      this.dialog_.open(AlertDialog, {data: config});
      this.loading = false;
      return throwError(error);
    }
    );
  }


  canDeactivate(): boolean {
    return this.userForm.pristine || this.created_;
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.resourcesListDictionary.filter(option => option && option.name && option.name.toLowerCase().includes(filterValue));
  }
}
